

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiInstance from '../utils/apiInstance';
import countryCodes from '../utils/CountryCodes.json';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css'

const AddWaiter = () => {
    const { _id } = useParams();
    const [waiter, setWaiter] = useState({});
    const [countryCode, setCountryCode] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setCountryCode(countryCodes)
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files.length > 0) {
            const file = files[0];
            if (!file.type.startsWith("image/")) {
                toast.error("Please select a valid image file");
                return;
            }
            setWaiter((prevData) => ({
                ...prevData,
                [name]: file,
            }));
            setImagePreview(URL.createObjectURL(file));
        } else {
            setWaiter((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !waiter.country_code ||
            !waiter.name?.trim() ||
            !waiter.location ||
            !waiter.phone ||
            !waiter.email ||
            !waiter.password ||
            !waiter.confirmPassword
        ) {
            toast.error("Please fill in all fields");
            return;
        }
        if (!waiter.image) {
            toast.error("Please select an image");
            return
        }
        if (waiter.image && waiter.image.size > (1024 * 1024 * 6)) {
            toast.error("Image size must be less than 6MB");
            return;
        }
        if (!/^[A-Za-z\s]+$/.test(waiter.name)) {
            toast.error("Please enter a valid name");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(waiter.email)) {
            toast.error("Enter a valid email address");
            return;
        }
        if (isNaN(waiter.phone)) {
            toast.error("Enter a valid phone number");
            return;
        }
        if (waiter.password.length < 5 || waiter.password.length > 12) {
            toast.error("Password should be between 5 and 12 characters");
            return;
        }
        if (waiter.password !== waiter.confirmPassword) {
            toast.error("Password and Confirm Password do not match");
            return;
        }


        const formData = new FormData();
        formData.append("country_code", waiter.country_code);
        formData.append("name", waiter.name);
        formData.append("phone", waiter.phone);
        formData.append("email", waiter.email);
        formData.append("location", waiter.location)
        formData.append("image", waiter.image);
        formData.append("password", waiter.password);
        setLoading(true);
        try {
            await apiInstance.post(`/addWaiter/${_id}`, formData);
            toast.success("Waiter added successfully");
            setTimeout(() => {
                navigate(-1);
            }, 1000);
        } catch (error) {
            if (error.response) {
                toast.error(
                    `${error.response.data?.message || "Something went wrong"
                    }`
                );
            } else {
                toast.error("Request failed: Network error or server is down");
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={true} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card my-4">
                            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div className="bg-info shadow-dark border-radius-lg">
                                    <h6 className="text-white text-capitalize ps-3">
                                        Add Waiter
                                    </h6>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                                {loading && (
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                                            zIndex: 1000,
                                        }}
                                    >
                                        <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <div className="card-body">
                                    <div className="form-group col-3 mx-auto d-flex justify-content-center">
                                        <div className="waiter_profile mt-2" data-aspect="1/1">
                                            <img
                                                src={imagePreview || "/noimage.png"}
                                                alt="Preview"
                                                style={{
                                                    borderRadius: "10px",
                                                    width: "200px",
                                                    height: "200px",
                                                    marginBottom: "5px",
                                                }}
                                            />
                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control "
                                                onChange={handleChange}
                                                accept=".jpg,.jpeg,.png"
                                                style={{
                                                    paddingLeft: "10px",
                                                    color: 'white',
                                                    width: '200px'
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col-lg-6'>
                                            <div className="form-group mb-2">
                                                <label htmlFor="name">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control "
                                                    required
                                                    autoComplete='off'
                                                    name="name"
                                                    value={waiter.name || ""}
                                                    onChange={handleChange}
                                                    style={{
                                                        paddingLeft: "10px",
                                                        color: 'white'
                                                    }}
                                                />
                                            </div>

                                            <div className="form-group mb-2">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control "
                                                    required
                                                    autoComplete='off'
                                                    name="email"
                                                    value={waiter.email || ""}
                                                    onChange={handleChange}
                                                    style={{
                                                        paddingLeft: "10px",
                                                        color: 'white'
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group mb-2">
                                                <label htmlFor="phone">Phone No.</label>
                                                <div className="d-flex">
                                                    <select
                                                        name="country_code"
                                                        className="form-control  cursor-pointer me-1"
                                                        required
                                                        value={waiter.country_code || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            width: '75px',
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    >
                                                        <option value="">c.code</option>

                                                        {countryCode.map((code, index) => (
                                                            <option key={index} value={code.code}>
                                                                {code.code}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    <input
                                                        type="tel"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="phone"
                                                        value={waiter.phone || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            flex: 1,
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group mb-2">
                                                <label htmlFor="password">Password</label>
                                                <div className="input-group position-relative">
                                                    <input
                                                        type={passwordVisible ? "text" : "password"}
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="password"
                                                        value={waiter.password || ""}
                                                        onChange={handleChange}
                                                        maxLength={12}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                    <i onClick={togglePasswordVisibility} className={`fas ${passwordVisible ? 'fa-eye' : 'fa-eye-slash'}`} style={{ position: "absolute", right: '5px', top: '14px', zIndex: '10', cursor: 'pointer', color: 'black' }} />
                                                </div>
                                            </div>
                                            <div className="form-group mb-2">
                                                <label htmlFor="confirmPassword">Confirm Password</label>
                                                <div className="input-group position-relative">
                                                    <input
                                                        type={confirmPasswordVisible ? "text" : "password"}
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="confirmPassword"
                                                        value={waiter.confirmPassword || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                    <i onClick={toggleConfirmPasswordVisibility} className={`fas ${confirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash'}`} style={{ position: "absolute", right: '5px', top: '14px', zIndex: '10', cursor: 'pointer', color: 'black' }} />
                                                </div>
                                            </div>

                                            <div className="form-group mb-2">
                                                <label htmlFor="address">Address</label>
                                                <input
                                                    type="text"
                                                    className="form-control "
                                                    required
                                                    autoComplete='off'
                                                    name="location"
                                                    value={waiter.location || ""}
                                                    onChange={handleChange}
                                                    style={{
                                                        paddingLeft: "10px",
                                                        color: 'white'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mx-4 text-end">
                                    <button
                                        type="submit"
                                        className="btn btn-info"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Add
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddWaiter;


